import { Routes } from '@angular/router';
import { shareTokenGuard } from './guards/share-token.guard';
import { EvidencePageComponent } from './pages/evidence-page/evidence-page.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { OpenDocumentComponent } from './pages/open-document/open-document.component';

export const routes: Routes = [
  {
    path: ':token/open/:itemId',
    canMatch: [shareTokenGuard],
    component: OpenDocumentComponent
  },
  {
    path: ':token',
    canMatch: [shareTokenGuard],
    component: EvidencePageComponent
  },
  { path: '**', component: NotFoundComponent }
];
